import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarousel from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const logos = [
  carouselLogos.BONOBOS,
  carouselLogos.DIGITAL_OCEAN,
  carouselLogos.ATLASSIAN,
  carouselLogos.THE_SKIMM,
  carouselLogos.RITUAL,
  carouselLogos.SHIFT,
  carouselLogos.TRADESY,
  carouselLogos.IBM,
  carouselLogos.DOMINOS,
  carouselLogos.LEVIS,
  carouselLogos.ALLERGAN,
]

const LogoCarouselSection: FC = () => (
  <StyledSectionBase variant="centered">
    <LogoCarousel logos={logos} />
  </StyledSectionBase>
)

export default LogoCarouselSection

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`
